if (localStorage.getItem("scroll-to-search")) {
  localStorage.removeItem("scroll-to-search")
  Viewport.scrollTo($("#search-form-anchor, #search-form-mobile"))
}

if (Detector.isMobile) {
  addEventListener("hb:search-form:close", (event) => {
    requestAnimationFrame(() => {
      document.getElementById("search-form-mobile").scrollIntoView()
    })
  })
}
